import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/compound-savings-optimizer',
  component: () => import('../../routes/CompoundSavingsOptimizer.svelte'),
  card: {
    id: 'compound-savings-optimizer',
    title: 'Compound Savings Optimizer',
    description: 'Calculate how much your savings will grow with regular monthly contributions and compound interest.',
    icon: 'savings',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/compound-savings-optimizer',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Compound Savings Optimizer Calculator – Future Value with Monthly Contributions',
    description: 'Calculate the future value of your savings with regular monthly contributions and compound interest. Optimize your savings strategy with our free calculator.',
  },
};

export default meta;
